export default {
    title: "Data Set",
    list: {
        confirm_delete_title: "Would you like to delete",
        confirm_delete_body:
            "To avoid unexpected errors, ensure your set is not being used in any automation/campaign.",
        empty_alert: "You don't have any Data Sets yet,",
        create_first: "create the first one now!",
        filter_placeholder: "Filter by Data Set Name",
        create_new: "Create New Data Set",
        edit_tooltip: "Edit data set",
        delete_tooltip: "Delete data set",
        no_results: "No data sets found with",
        error_loading: "Error loading data sets.",
        error_deleting: "Error deleting data set.",
        delete_success: "Data Set deleted successfully!",
    },
    form: {
        edit_title: "Edit Data Set",
        new_title: "New Data Set",
        back: "Back",
        basic_info: "Basic Information",
        name_label: "Data Set Name",
        name_placeholder: "Ex: Products on Sale",
        description_label: "Description",
        description_placeholder: "Describe the purpose of this data set...",
        characters: "characters",
        data_structure: "Data Structure",
        data_structure_help:
            "Configure the columns and values of your data set",
        edit_with_ai: "Edit with AI",
        processing: "Processing...",
        key_column: "Key",
        column_name_placeholder: "Column Name",
        default_value: "Default Value",
        value_placeholder: "Value",
        new_key_placeholder: "New Key",
        validation_empty_dataset: "Add at least one row to the data set.",
        validation_empty_headers: "All column names must be filled",
        validation_name_required: "Name field cannot be empty",
        validation_description_max:
            "Description field cannot exceed 250 characters",
        error_loading: "Error loading data set.",
        error_saving: "Error saving data set.",
        edit_success: "Data Set edited successfully!",
        create_success: "Data Set created successfully!",
        saving: "Saving...",
        save_button: "Save Data Set",
        cancel: "Cancel",
        ai_modal_title: "Generate/Edit Dataset with AI",
        ai_modal_current: "Current Dataset",
        ai_modal_columns: "Columns:",
        ai_modal_rows: "Rows:",
        ai_modal_instructions: "Instructions for AI",
        ai_modal_placeholder:
            "Describe what you would like to create or modify. For example:\n\nCREATE NEW DATASET:\n- Create a tech products dataset with columns: Name, Category, Price, Brand, Stock. Generate 15 varied products\n- Generate a customers dataset with 20 records including name, email, phone, city, signup_date\n- Create a promotions dataset with columns: Title, Discount, Validity, Category, Code\n\nMODIFY EXISTING:\n- Add a 'Price' column with values between $10 and $100\n- Create 5 new rows with tech products\n- Modify the 'Category' column to include 'Electronics'\n\nIMPORT DATA:\n- Paste CSV or JSON data here to import\n\nAI can generate completely new datasets or modify the existing one!",
        ai_loading_messages: [
            "Analyzing your instructions...",
            "Processing the current dataset...",
            "Generating data with AI...",
            "Applying modifications...",
            "Finalizing the dataset...",
            "Almost ready...",
            "Just a moment...",
        ],
        ai_modal_generate: "Generate Dataset",
        validation_duplicate_key: "Error: Key '{0}' already exists.",
        ai_success: "Dataset generated/updated with AI!",
        ai_error_process: "Error processing with AI",
        ai_error_connection: "Error communicating with server",
        ai_error_generic: "Error processing changes with AI. Try again.",
    },
};
